export default {
  className: 'excellentCases',
  fields: [
    'articleTitle',
    'IntroductionEvent',
    {
      name: 'readingSum',
      note: '阅读量',
      disabled: true
    },
    'isTop'
  ],
  search: [
    'articleTitle'
  ],
  hooks: {
    // 保存数据前判断
    async beforeSave (options) {
      let data = options.data
      if (!options.objectId && !data.isTop) { // 新建当中判断isTop是否存在
        data.isTop = false
      }
    }
  }
}
